import { formatNumber } from '@witmetrics/utils/strings';

export const classes = {
  label:
    'inline-flex items-center rounded-full px-[11px] py-1 text-[11.5px] font-semibold leading-none bg-black/[0.05] text-taupe-2 dark:bg-white/[0.07] dark:text-mauve-2',
};

export function parseTokenCount(price?: string) {
  const parsed = price ? parseFloat(price) : 0;
  return formatNumber(isNaN(parsed) ? 0 : parsed, 1);
}
